import {memo, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {
    setBlockLeftMenuMobileOpen,
    setDateRangeCriteria,
    setDrawerOpen,
    setGeoObjCriteria,
    setRangeEndDate,
    setRangerHeight,
    setRangeStartDate,
    setShowRouteTooltips
} from '../../../actions/ui'

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DateRanger from '../../../UIComponents/DateRanger'

import s from '../../DocsMain/docs.module.css'
import useStyles from "./useStyles";
import {Checkbox, Stack} from "@mui/material";
import dayjs from "dayjs";
import CalendarIcon from '../../../icons/CalendarSvg';
import {periodTypes} from '../../../const';
import {getNowEnd} from '../../../tools';
import Button from "../Button/Button";
import RollUpSvg from "../../../icons/RollUpSvg";
import {BlockLeftMain} from "../../../Components/main/BlockLeftMain";
import TablerList from "../../../icons/TablerList";

const mapStateToProps = (state) => {
    const {
        geozone: {
            geozoneSettingsArr = [],
        },
        ui: {
            geoObjCriteria,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
            isDrawerOpen,
            isLeftMenuMobileOpen,
            isShowRouteTooltips
        } = {},


    } = state;
    return {
        geoObjCriteria,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        geozoneSettingsArr,
        isDrawerOpen,
        isLeftMenuMobileOpen,
        isShowRouteTooltips
    }
}

const formatPeriodToShow = (dateStart, dateEnd, periodType = periodTypes.PERIOD) => {

    const dateFormat = 'DD.MM.YY HH:mm'

    const formattedDateStart = dayjs(dateStart).format(dateFormat)
    const formattedDateEnd = dayjs(dateEnd).format(dateFormat)
    const defaultPeriodStr = `${formattedDateStart} - ${formattedDateEnd}`

    switch (periodType) {
        /* - Период - отображается как С и По, например "13.01.2024 15:00 - 15.01.2024 09:00" */
        case periodTypes.PERIOD:
        case periodTypes.WEEK:
            return defaultPeriodStr
        /* сегодня отображается как текущая дата, например "17.01.2024 с 00:00:00 по 23:59:59" */
        case periodTypes.TODAY:
            return `${dayjs(dateStart).format("DD.MM.YY")} c ${dayjs(dateStart).format("HH:mm:ss")} по ${dayjs(dateEnd).format("HH:mm:ss")}`
        default:
            return defaultPeriodStr
    }
}

const RadioGroup2 = (props) => {
    const {
        enableGeo = null,
    } = props

    const {
        geoObjCriteria,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        isDrawerOpen,
        isLeftMenuMobileOpen,
        isShowRouteTooltips
    } = useSelector(mapStateToProps);


    const dispatch = useDispatch()
    const container = useRef(null);
    const [dialogOpen, setDialogOpen] = useState(false)

    const periodTypeActive = dateRangeCriteria
    const setPeriodTypeActive = (period) => dispatch(setDateRangeCriteria(period))

    useEffect(() => {
        if (container?.current?.clientHeight) {
            dispatch(setRangerHeight(container.current.clientHeight + 1))
        }
    }, [geoObjCriteria])

    useEffect(() => {
        const handleResize = () => {
            dispatch(setBlockLeftMenuMobileOpen(false))
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const changeRadio = (e) => {
        if (e?.target?.value) dispatch(setGeoObjCriteria(e.target.value))
    }

    const radioStyles = {
        display: "none"
    }

    const classes = useStyles()

    const chosenPeriod = useMemo(() => {

        return formatPeriodToShow(rangeStartDate, rangeEndDate, periodTypeActive)
    }, [rangeStartDate, rangeEndDate, periodTypeActive])

    const handleCloseDialog = useCallback(() => {
        setDialogOpen(false);
    }, []);

    const periodHandle = useCallback((e) => {
        e.stopPropagation()
        setDialogOpen(!dialogOpen)
        setPeriodTypeActive(periodTypes.PERIOD)
    }, [dialogOpen])
    /*-------------------------------------*/

    const periodToday = () => {
        // сбросить период до сегодняшней даты (00 часов 00 минут 00 секунд) !!!
        dispatch(setRangeStartDate(new Date(new Date().setHours(0, 0, 0, 0))))
        // по текущий момент !!!
        dispatch(setRangeEndDate(getNowEnd()))
        setPeriodTypeActive(periodTypes.TODAY)
    }

    const periodWeek = () => {
        // сбросить период до 7 дней назад !!!
        dispatch(
            setRangeStartDate(
                dayjs(new Date().setHours(0, 0, 0, 0)).subtract(6, 'day').toDate())
        )
        // по текущий момент !!!
        dispatch(setRangeEndDate(getNowEnd()))
        setPeriodTypeActive(periodTypes.WEEK)
    }

    const toggleDrawer = () => {
        dispatch(setDrawerOpen(!isDrawerOpen))
    }

    const toggleMenu = () => {
        dispatch(setBlockLeftMenuMobileOpen(!isLeftMenuMobileOpen))
    }

    const toggleShowTooltips = () => {
        dispatch(setShowRouteTooltips(!isShowRouteTooltips))
    }

    return (
        <Stack ref={container} className={s.checkboxContainer}>
            <RadioGroup
                onChange={changeRadio}
                value={geoObjCriteria}
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className={classes.radioGroup}
            >

                {isLeftMenuMobileOpen ? (
                    <div className={classes.mobileMenu}>
                        <BlockLeftMain />
                    </div>
                ): (

                    <div className={classes.choosePeriodContainer}>

                        <Button
                            className={classes.burgerMenuToggler}
                            onClick={toggleMenu}
                            children={<TablerList />}/>

                        {!isDrawerOpen && (
                            <Button
                                className={classes.toggleDrawerBtn}
                                onClick={toggleDrawer}
                            >
                                <span>Открыть панель</span>
                                <RollUpSvg />
                            </Button>
                        )}

                        <div className={classes.choosePeriodBtnWrapper}>
                            <Button
                                onClick={periodToday}
                                title={"За сегодня"}
                                className={`${classes.periodBtn} ${periodTypeActive === periodTypes.TODAY ? classes.periodActive : ''}`}
                            >
                                <CalendarIcon type={periodTypes.TODAY} />
                            </Button>

                            <Button
                                onClick={periodWeek}
                                title={"За неделю"}
                                className={`${classes.periodBtn} ${periodTypeActive === periodTypes.WEEK ? classes.periodActive : ''}`}
                            >
                                <CalendarIcon type={periodTypes.WEEK} />
                            </Button>

                            <Button
                                onClick={periodHandle}
                                title={"За период"}
                                className={`${classes.periodBtn} ${periodTypeActive === periodTypes.PERIOD ? classes.periodActive : ''}`}
                            >
                                <CalendarIcon
                                    type={periodTypes.PERIOD}
                                />
                            </Button>
                        </div>

                        <div className={classes.chosenPeriod}>
                            <div className={classes.period}>{chosenPeriod}</div>

                        </div>

                        <div>
                            <Checkbox
                                onClick={toggleShowTooltips}
                                checked={isShowRouteTooltips}
                                title={`${isShowRouteTooltips ? 'скрыть' : 'показать'} временные точки`}
                                className={classes.togglerRouteTooltips}
                                disabled={geoObjCriteria === "2" || !enableGeo}
                            />
                        </div>

                    </div>)}

                {enableGeo !== null ? (
                    <div className={classes.rightPartContainer}>
                        <FormControlLabel
                            className={geoObjCriteria === "1" ? classes.formControlLabelActive : classes.formControlLabel}
                            value="1"
                            control={<Radio sx={{ ...radioStyles }} />}
                            label="Трекеры"
                        />
                        <FormControlLabel
                            className={geoObjCriteria === "2" ? classes.formControlLabelActive : classes.formControlLabel}
                            value="2"
                            control={<Radio sx={{ ...radioStyles }} />}
                            label="Геозоны"
                        />
                    </div>
                ) : null}

            </RadioGroup>

            <DateRanger
                open={dialogOpen}
                onClose={handleCloseDialog}
            />
        </Stack>
    )
}

export default memo(RadioGroup2);